import React, { useState } from "react";
import { toast } from "react-toastify";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Router, useNavigate } from "react-router-dom";
import PrintIcon from "@mui/icons-material/Print";

// import JS files
// import OrderDetails from "./OrderDetails";
import MuiButton from "../../../shares/MuiButton";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useUserData } from "../../../../context/UserDataContext";
import PanelTable from "../../../shares/PanelTable";

const AdminGetProviderBangle = () => {
  const navigate = useNavigate();
  const [codeFilter, setCodeFilter] = useState(null);
  const [stateFilter, setStateFilter] = useState(null);
  const [providerFilter, setProviderFilter] = useState("all");

  const headersList = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "brand", name: "برند" },
    { colName: "gender", name: "سن" },
    { colName: "color", name: "رنگ" },
    // { colName: "name", name: "نام تولیدکننده" },
    { colName: "weight_one", name: " یک" },
    { colName: "weight_two", name: " دو" },
    { colName: "weight_three", name: " سه" },
    { colName: "weight_four", name: " چهار" },
    { colName: "weight_five", name: " پنج" },
    { colName: "weight_six", name: " شش" },
    // { colName: "register", name: " ثبتی ادمین" },
  ];

  const mobileHeadersList = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "brand", name: "برند" },
  ];

  const dataKey = [
    "object.bangle.code",
    "object.bangle.show_name",
    "object.bangle.brand_name",
    "object.bangle.fa_gender",
    "object.bangle.fa_color",
    // "object.bangle.name",
    "object.total.size_one_num",
    "object.total.size_two_num",
    "object.total.size_three_num",
    "object.total.size_four_num",
    "object.total.size_five_num",
    "object.total.size_six_num",
  ];
  const { userData } = useUserData();

  const [providerPagination, setProviderPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [providerList, setProviderList] = useState([]);

  const getProvidersApi = useFetch({
    method: "get",
    url: "Provider_Service/get_providers",

    trigger: true,
    pagination: providerPagination,
    setter: setProviderList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [brandFilter, setBrandFilter] = useState(null);
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const [brandsList, setBrandsList] = useState({ results: [] });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    // params: {
    //   pr: userData.username,
    // },
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const filterList = [
    {
      type: "select",
      label_fa: "تولیدکننده",
      label_en: "provider",
      state: providerFilter,
      menuItems: providerList,
      fromApi: true,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",

      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "brand") setBrandFilter(e);

    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "state") setStateFilter(e.length > 0 ? e : null);
    if (state == "provider") setProviderFilter(e);
  };

  const filter = () => {
    getRequestListApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    setStateFilter(null);
    setBrandFilter(null);

    setProviderFilter(providerList.results[0].id);
    getRequestListApi.reFetch();
  };

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const handelPrintReport = () => {
    navigate(`/print-report-provider-bangle/${providerFilter}`);
  };

  const [requestList, setRequestList] = useState([]);
  const getRequestListApi = useFetch({
    method: "get",
    params: {
      //   code: fixNumbers(codeFilter),
      provider: providerFilter,
      brand: brandFilter == "all" ? null : brandFilter,

      //   state: stateFilter,
    },
    trigger: true,

    url: `User_Service/${userData.username}/admin_get_provider_current_bangle_request`,
    argFunc: (res) => {
      setRequestList(res.data);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const buttonsList = [
    // {
    //   label: "ثبتی ادمین",
    //   component: (it) => (
    //     <OrderDetails RemoveOrder selectedRow={it} data={it.request_extra} />
    //   ),
    // },
  ];

  const actionsList = [];

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRequestList([]);
    getRequestListApi.reFetch();
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="r-request-provider-bangle">
        <div className="panel-main-header">
          <span> وضعیت النگو تولید کنندگان</span>
        </div>
        <PanelFilter
          header="فیلتر :"
          list={filterList}
          update_filter={update_filter}
          filter={filter}
          reset_filter={reset_filter}
          dontShowAllOption
        />
        <div className="flex justify-end">
          <MuiButton
            onClick={handelPrintReport}
            variant="outlined"
            icon={<PrintIcon />}
            color="primary"
            text="چاپ گزارش"
            margin="mr-2"
          />
        </div>
        <PanelTable
          header="لیست النگوها:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={requestList}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AddShoppingCartIcon />}
        />
      </PanelTemplate>
    </>
  );
};

export default AdminGetProviderBangle;
